;
define("product_list_details_later.tpl", function(){});

